import React from "react";
import H3Text from "../../../../../components/components-text/h3-text";
import { InitialNoDataContainer } from "./no-data-style";

const NoData = ({ message }: { message: string }) => {
  return (
    <InitialNoDataContainer>
      <H3Text>
        <p>{message && typeof message === "string" ? message : ""}</p>
      </H3Text>
    </InitialNoDataContainer>
  );
};

export default NoData;
